import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import QuestionContent from './QuestionContent'
import QuestionPosition from './QuestionPosition'

type QuestionContentProps = React.ComponentProps<typeof QuestionContent>

interface Props extends QuestionContentProps {
  position?: number
}

export default function Question({ position, mandatory = false, ...otherProps }: Props) {
  return (
    <Box flexDirection="row" gap="s16" width="full">
      <Box flexNoShrink>{position && <QuestionPosition position={position} />}</Box>
      <Box gap="s8" flexGrow minWidth="none">
        <QuestionContent mandatory={mandatory} {...otherProps} />
      </Box>
    </Box>
  )
}
